import apiClient from './apiClient';

const contactService = {
  sendContactForm: async (formData) => {
    try {
      const response = await apiClient.post('/contact', formData);
      return response.data;
    } catch (error) {
      throw error;
    }
  }
};

export default contactService; 